module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-detailed-statistics-1409632163999535edbb9d4cef06971f.png";